module.exports = __webpack_public_path__ + "static/media/chosen-few.662bd863.jpeg";